var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {}; // Functions placed here will be ran at different points in the boot sequence
OCS.BootFunctions.viewer = OCS.BootFunctions.viewer || {};

OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Classes.Utilities = OCS.Viewer.Classes.Utilities || {};
/**
 * @module Viewer
 * @class Utilities
 * 
 */

OCS.BootFunctions.viewer.define_utilities_classes = function () {
    OCS.Viewer.Classes.Utilities.generic = new Class({
        ucwords: function (str) {
            // http://kevin.vanzonneveld.net
            // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
            // +   improved by: Waldo Malqui Silva
            // +   bugfixed by: Onno Marsman
            // +   improved by: Robin
            // +      input by: James (http://www.james-bell.co.uk/)
            // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // *     example 1: ucwords('kevin van  zonneveld');
            // *     returns 1: 'Kevin Van  Zonneveld'
            // *     example 2: ucwords('HELLO WORLD');
            // *     returns 2: 'HELLO WORLD'
            return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
                return $1.toUpperCase();
            });
        },
        make_sure_two_digits: function (num) {
            if (num.toString().length === 1) {
                return "0" + num;
            } else {
                return num;
            }
        },

        get_parm_name: function (in_id) {
            var id = in_id;
            var name = '';
            Object.each(OCS.Viewer.Config.param_info.parm, function (parm) {
                if (parm.id === id) {
                    name = parm.name;
                    return false;
                }
            });
            return name;
        },
        get_parm_short_name: function (in_id) {
            var id = in_id;
            var short_name = '';
            Object.each(OCS.Viewer.Config.param_info.parm, function (parm) {
                if (parm.id === id) {
                    short_name = parm.short_name;
                    return false;
                }
            });
            return short_name;
        },
        get_radar_site_properties: function (site_id) {
            return this.array_has_object_with_cond(OCS.Viewer.Config.default_radar_locations, function (location) {
                return location.id === site_id;
            });
        },
        get_radar_product_properties: function (product_id) {
            return this.array_has_object_with_cond(OCS.Viewer.Config.default_radar_products, function (product) {
                return product.product === product_id;
            });
        },
        makeUUID: function () {
            return this.create_unique_id();
        },
        unit_to_displayunit: function (unit) {
            if (typeof OCS.Viewer.Config.unit_displayunits[unit] !== 'undefined')
                return OCS.Viewer.Config.unit_displayunits[unit];
            return unit;
        },

        process_category_type: function (piece, data_category_keys) {
            var value = piece[1];
            switch (data_category_keys[piece[0]]) {
                case "Boolean":
                    if (String(value).toLowerCase() === 'true' || value === "1") {
                        value = true;
                    }
                    if (String(value).toLowerCase() === 'false' || value === 0) {
                        value = false;
                    }
                    break;
                case "Integer":
                    value = value * 1;
                    break;
                case "JSON":
                    value = JSON.parse(value);
                    break;
                default:
                    break;
            }
            return value;
        },
        encode_category_type: function (value, type) {
            switch (type) {
                case "JSON":
                    value = JSON.stringify(value);
                    break;
                default:
                    break;
            }
            return value;
        },
        make_data_request_category_key: function (metadata, data_category_keys) {
            if (!data_category_keys) {
                data_category_keys = {'req_cat_type': 'String', 'dataset': "String", 'grid': "Boolean", 'variables': "JSON", timestamp: "Integer"};
            }
            var str = [];
            var keys = Object.keys(data_category_keys);
            keys.each(function (key) {
                if (metadata[key] !== undefined) {
                    str.push(key + "-|:-" + this.encode_category_type(metadata[key], data_category_keys[key]));
                }
            }.bind(this));
            return str.join("-/-");
        },
        unmake_data_request_category_key: function (category_key, data_category_keys) {
            if (!data_category_keys) {
                data_category_keys = {'req_cat_type': 'String', 'dataset': "String", 'grid': "Boolean", 'variables': "JSON", timestamp: "Integer"};
            }
            var i, piece;
            var options = {};
            var pieces = category_key.split('-/-');
            for (i = 0; i < pieces.length; i++) {
                piece = pieces[i].split('-|:-');
                if (piece.length === 2 && data_category_keys[piece[0]]) {
                    options[piece[0]] = this.process_category_type(piece, data_category_keys);
                }
            }
            return options;
        }

    });
    OCS.Viewer.Classes.Utilities.gridded_data = new Class({
        /**
         * Creates an interpolated dataset
         *
         * @method interpolate_data
         * @param data {Array} data set to interpolate
         * @param factor {int} The interpolation factor for how much interpolation to do between points
         */
        interpolate_data: function (data, factor) {
            var fractionXStepSize = 1 / factor;
            var fractionYStepSize = 1 / factor;
            var fractionX = 0;
            var fractionY = 0;
            var ur_data = 0;
            var ll_data = 0;
            var lr_data = 0;
            var ul_data, datarow, datacol, intdatarow, intdatacol;

            var newData = [];

            for (datarow = 0; datarow < data.length - 1; datarow++) {
                //y values
                for (datacol = 0; datacol < data[datarow].length - 1; datacol++) {
                    //x values	
                    ul_data = data[datarow][datacol];
                    ur_data = data[datarow][datacol + 1];
                    ll_data = data[datarow + 1][datacol];
                    lr_data = data[datarow + 1][datacol + 1];
                    if (ul_data === null || ur_data === null || ll_data === null || lr_data === null) {
                        continue;
                    }

                    fractionX = 0;
                    fractionY = 0;

                    for (intdatarow = 0; intdatarow <= factor; intdatarow++)
                    {
                        if (newData[(datarow * factor) + intdatarow] === undefined) {
                            newData[(datarow * factor) + intdatarow] = [];
                        }

                        for (intdatacol = 0; intdatacol <= factor; intdatacol++)
                        {
                            newData[(datarow * factor) + intdatarow][(datacol * factor) + intdatacol] = this.interpolate_values(ul_data, ur_data, ll_data, lr_data, fractionX, fractionY);

                            fractionX += fractionXStepSize;
                        }
                        fractionX = 0;
                        fractionY += fractionYStepSize;
                    }
                }
            }

            return newData;
        }, //interpolate_data
        interpolate_values: function (ul_data, ur_data, ll_data, lr_data, fractionX, fractionY) {
            var interpolatedValueX1 = this.interpolateValue(ul_data, ur_data, fractionX);
            var interpolatedValueX2 = this.interpolateValue(ll_data, lr_data, fractionX);
            return this.interpolateValue(interpolatedValueX1, interpolatedValueX2, fractionY);
        },
        /**
         * Creates index bins for interpolated y values.
         *
         * @method interpolateValue
         */
        interpolateValue: function (value1, value2, frac) {
            ~~value1;
            ~~value2;

            return value1 + ((value2 - value1) * frac);
        } //interpolateValue



    });
    OCS.Viewer.Functions.init_utilities();
};
OCS.Viewer.Functions.init_utilities = function () {
    OCS.Functions.init_utilities();
    if (OCS.is_worker) {
        OCS.Viewer.Classes.Utilities.worker = new Class({
            Extends: OCS.Classes.Utilities.worker,
            Implements: [OCS.Viewer.Classes.Utilities.generic, new Class(OCS.Interfaces.UniqueId)]
        });
        OCS.Viewer.Live.Utilities = new OCS.Viewer.Classes.Utilities.worker();
    } else {
        OCS.Viewer.Classes.Utilities.general = new Class({
            Extends: OCS.Classes.Utilities.general,
            Implements: [OCS.Viewer.Classes.Utilities.generic, OCS.Viewer.Classes.Utilities.gridded_data, new Class(OCS.Interfaces.UniqueId)],
        });
        OCS.Viewer.Live.Utilities = new OCS.Viewer.Classes.Utilities.general();
    }
    return OCS.Viewer.Live.Utilities;
};
OCS.BootFunctions.viewer.define_utilities_classes();
OCS.Viewer.Functions.init_utilities();

OCS.Viewer.Functions.get_utilities = function () {
    if (OCS.Viewer.Live.Utilities) {
        return OCS.Viewer.Live.Utilities;
    } else {
        return OCS.Viewer.Functions.init_utilities();
    }
};


String.prototype.capitalize = function () {
    return this.replace(/(^|\s)([a-z])/g, function (m, p1, p2) {
        return p1 + p2.toUpperCase();
    });
};

